"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lastDecimalPointIndex = exports.hasMoreThanOneDecimalPoint = exports.occurringDecimalPoints = exports.hasDecimalPoints = exports.KnownIncarnations = void 0;
// all known kinds of decimal points
exports.KnownIncarnations = [".", ","];
// see if there are any decimal points of incarnation "decimalPoint" in the number value
const hasDecimalPoints = (numberValue, decimalPoint) => {
    return numberValue.indexOf(decimalPoint) >= 0;
};
exports.hasDecimalPoints = hasDecimalPoints;
// see if there is more than one decimal point of incarnation "decimalPoint" in the number value
const _hasMoreThanOneDecimalPoint = (numberValue, decimalPoint) => {
    const firstDecimalPointIndex = numberValue.indexOf(decimalPoint);
    const lastDecimalPointIndex = numberValue.lastIndexOf(decimalPoint);
    return firstDecimalPointIndex !== lastDecimalPointIndex;
};
// take the list of decimal point incarnations "decimalPoints" and return the ones occurring in the number value
const occurringDecimalPoints = (numberValue, decimalPoints) => {
    return decimalPoints.filter(decimalPoint => (0, exports.hasDecimalPoints)(numberValue, decimalPoint));
};
exports.occurringDecimalPoints = occurringDecimalPoints;
// test if there is more than one decimal point of incarnations "decimalPoints" in the number value
const hasMoreThanOneDecimalPoint = (numberValue, decimalPoints) => {
    if ((0, exports.occurringDecimalPoints)(numberValue, decimalPoints).length > 1) {
        // more than one kind of decimal point => more than one decimal point => return true
        return true;
    }
    const moreThanOne = decimalPoints.some(decimalPoint => _hasMoreThanOneDecimalPoint(numberValue, decimalPoint));
    if (moreThanOne) {
        // more than one decimal point of a kind => return true
        return true;
    }
    return false;
};
exports.hasMoreThanOneDecimalPoint = hasMoreThanOneDecimalPoint;
const lastDecimalPointIndex = (numberValue, decimalPoints) => {
    const lastIndices = decimalPoints
        .map(decimalPoint => numberValue.lastIndexOf(decimalPoint));
    const lastIndex = Math.max.apply(null, lastIndices);
    return lastIndex;
};
exports.lastDecimalPointIndex = lastDecimalPointIndex;
